export const UPDATE_ETOS_CHECKBOX_STATE = 'UPDATE_ETOS_CHECKBOX_STATE';
export const ENABLE_EXP_BUTTON = 'ENABLE_EXP_BUTTON';
export const SUBMIT_BUTTON_CLICK = 'SUBMIT_BUTTON_CLICK';
